import getClassNameReduxUtil from '../get-class-name'
import isInstanceReduxUtil from '../is-instance'

export default function getUpdatedDataReduxUtil (instance) {
  if (!instance) {
    return
  }

  let updates
  if (isInstanceReduxUtil(instance)) {
    updates = {
      ...instance.data, ...instance.changed
    }
  } else {
    updates = instance
  }

  return {
    className: getClassNameReduxUtil(instance), ...updates
  }
}
